import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  getPlatformDevices,
  getPlatformLocations,
  getPlatformOrganisations,
  getPlatformUsers,
  setPlatformUserStatus,
} from "../api/platform";

export const useGetPlatformUsers = () =>
  useQuery({
    queryKey: ["platform", "users"],
    queryFn: getPlatformUsers,
    staleTime: 1000 * 60,
  });

export const useGetPlatformOrganisations = () =>
  useQuery({
    queryKey: ["platform", "organisations"],
    queryFn: getPlatformOrganisations,
    staleTime: 1000 * 60,
  });

export const useGetPlatformLocations = () =>
  useQuery({
    queryKey: ["platform", "locations"],
    queryFn: getPlatformLocations,
    staleTime: 1000 * 60,
  });

export const useGetPlatformDevices = () =>
  useQuery({
    queryKey: ["platform", "devices"],
    queryFn: getPlatformDevices,
    staleTime: 1000 * 60,
  });

export const useSetPlatformUserStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, deactivated }: { userId: string; deactivated: boolean }) =>
      setPlatformUserStatus(userId, deactivated),
    onSuccess: (res) => {
      toast.success(res?.message || "User status updated");
      queryClient.invalidateQueries({ queryKey: ["platform", "users"] });
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.errorMessage || "Failed to update user status");
    },
  });
};
